import { useState, useEffect, useCallback } from "react";
import {
  getRecentSearches,
  saveRecentSearch,
  clearRecentSearches,
} from "@/utils/localStorage";

export const useRecentSearches = () => {
  const [recentSearches, setRecentSearches] = useState<string[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  // Load recent searches on mount
  useEffect(() => {
    const loadRecentSearches = () => {
      try {
        const searches = getRecentSearches();
        setRecentSearches(searches);
      } catch (error) {
        console.error("Failed to load recent searches:", error);
        setRecentSearches([]);
      } finally {
        setIsLoading(false);
      }
    };

    loadRecentSearches();
  }, []);

  const addRecentSearch = useCallback((cityName: string) => {
    try {
      saveRecentSearch(cityName);
      const updatedSearches = getRecentSearches();
      setRecentSearches(updatedSearches);
    } catch (error) {
      console.error("Failed to save recent search:", error);
    }
  }, []);

  const clearAllRecentSearches = useCallback(() => {
    try {
      clearRecentSearches();
      setRecentSearches([]);
    } catch (error) {
      console.error("Failed to clear recent searches:", error);
    }
  }, []);

  return {
    recentSearches,
    isLoading,
    addRecentSearch,
    clearAllRecentSearches,
  };
};
